import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es7.promise.finally";
export default {
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: '控制台',

  /**
   * @description token在Cookie中存储的天数，默认1天
   */
  cookieExpires: 1,

  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: true,

  /**
   * @description api请求基础路径
   */
  baseUrl: {
    // dev: 'http://mouse.test.xcthings.com',
    dev: 'https://cn3.api.xcthings.com:6443/v3',
    // dev: 'https://bms-api.xcthings.com', //测试http://pcphp.test.xcthings.com http://www.pc.com
    alp: 'https://cn3.api.xcthings.com:6443/v3',
    pro: 'https://cn3.api.xcthings.com:6443/v3'
  },
  webLinkUrl: 'https://cn3.api.xcthings.com:6443/v3',

  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'home',

  /**
   * @description 需要加载的插件
   */
  plugin: {
    'error-store': {
      showInHeader: true,
      // 设为false后不会在顶部显示错误日志徽标
      developmentOff: true // 设为true后在开发环境不会收集错误信息，方便开发中排查错误

    }
  },

  /**
   * 加密key
   */
  jsencryptKey: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCYQ8dpNGpu0WYt89qAHcaKW0Ohb7Wmb03xLaoGPEJeTK5XvICiBeinjbAE6IVMeWbGt49RX1X2Z/3PmQCX2C9pUFU9+Kmtyp5iJJpwiItZbuVGQK9pG4GLRAMlPKeNDNOOJ304q93WLXd7bqSWtCZxe7H4V0O7o/dMRzqhCh7ykwIDAQAB'
};